import DOMPurify from 'dompurify';
import React, { Key } from 'react';

const commentRenderer = (value: string) => (
  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }} />
);

// src/features/variant_workflow/utils/referencesTableColumns.ts
export const referencesTableColumns = (
  filterByType?: string | ((type: string) => boolean),
  onHandleEditClick?: (record: any) => void,
) => [
  {
    title: 'Citation',
    key: 'citation',
    render: (_: any, record: any) => (
      <span>
        <a
          className="clinical-obs__report-category-link"
          onClick={() => onHandleEditClick?.(record)}
        >
          {record.publication.citekey}
        </a>
        - {record.publication.title}
      </span>
    ),
  },
  {
    title: 'Include in report',
    dataIndex: 'include_in_report',
    key: 'include_in_report',
    render: (value: boolean) => (value ? 'Yes' : 'No'),
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    filters: filterByType
      ? undefined
      : [
          { text: 'Cohort Study', value: 'cohort study' },
          { text: 'Case Study', value: 'case study' },
        ],
    onFilter: (value: boolean | Key, record: any) =>
      record.type === String(value),
  },
  {
    title: 'Variant included',
    dataIndex: 'variant_included',
    key: 'variant_included',
    render: (value: boolean) => (value ? 'Yes' : 'No'),
  },
  {
    title: 'Method',
    dataIndex: 'comment_materialmethod',
    key: 'm_method',
    render: commentRenderer,
  },
  {
    title: 'Result',
    dataIndex: 'comment_result',
    key: 'result',
    render: commentRenderer,
  },
  {
    title: 'Evidence',
    dataIndex: 'comment_evidence',
    key: 'evidence',
    render: commentRenderer,
  },
  {
    title: 'Conclusion',
    dataIndex: 'comment_conclusion',
    key: 'conclusion',
    render: commentRenderer,
  },
];
